import { render, staticRenderFns } from "./addReplenishment.vue?vue&type=template&id=fbc77d4c&scoped=true&"
import script from "./addReplenishment.vue?vue&type=script&lang=js&"
export * from "./addReplenishment.vue?vue&type=script&lang=js&"
import style0 from "./addReplenishment.vue?vue&type=style&index=0&id=fbc77d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc77d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbc77d4c')) {
      api.createRecord('fbc77d4c', component.options)
    } else {
      api.reload('fbc77d4c', component.options)
    }
    module.hot.accept("./addReplenishment.vue?vue&type=template&id=fbc77d4c&scoped=true&", function () {
      api.rerender('fbc77d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/replenishment/components/addReplenishment.vue"
export default component.exports